module.exports = __webpack_public_path__ + "media/images/help/emp_submission_mng_sdl-b05310f1a14eb70948a461de6fd0f6d6.png";